import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { CompanyStaffsContext } from 'contexts/CompanyStaffsContext'

import { Card } from 'antd'
import { StaffBoxItem } from './StaffBoxItem'

import { StaffBoxItemWrapper, StaffsBoxWrapper, StaffTypeTitle } from './styles'

interface IProps {
  type: string
}

const StaffsBox = (props: IProps) => {
  const { t } = useTranslation('companyStaffs')
  const { type } = props
  const { staffs } = useContext(CompanyStaffsContext)
  const currentStaffs = staffs.filter(staff => staff.role === type)

  return (
    <>
      {currentStaffs && currentStaffs.length > 0 && (
        <StaffsBoxWrapper>
          <Card
            bordered
            title={<StaffTypeTitle>{`${t(`roles.${type}`)}`}</StaffTypeTitle>}
            style={{ width: 'auto' }}
          >
            <StaffBoxItemWrapper>
              {currentStaffs.map(staff => (
                <StaffBoxItem staff={staff} key={`${type}-card-${staff.id}`} />
              ))}
            </StaffBoxItemWrapper>
          </Card>
        </StaffsBoxWrapper>
      )}
    </>
  )
}

export default StaffsBox
